import { Experience, FallbackCoverId } from '@/types'
import React from 'react'
import CroppedCloudinaryImage from './cropped-cloudinary-image'

interface ExperienceCoverImageProps {
  experience: Experience
  size?: 'normal' | 'compact'
}

const ExperienceCoverImage = ({
  experience,
  size = 'normal',
}: ExperienceCoverImageProps) => {
  const sizeClasses =
    size === 'compact' ? 'h-[120px] md:h-[160px]' : 'h-[190px] md:h-[260px]'

  return (
    <div className={`${sizeClasses} aspect-[5/6] relative overflow-hidden flex items-center`}>
      <CroppedCloudinaryImage
        width="356"
        height="436"
        src={experience.images?.[0] ?? FallbackCoverId}
        alt={experience.name}
        className="w-full h-full object-cover rounded-md"
      />
    </div>
  )
}

export default ExperienceCoverImage
